module.exports = __webpack_public_path__ + "static/img/9.3fa1f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/9.png
// module id = bMRE
// module chunks = 0